import axios from "axios";


const baseUrl = 'https://api.mapbox.com/'
const session_token = '05948f10-2220-4f2c-8249-06f50dc5a987'
const access_token = window.__env__?.REACT_APP_MAPBOX_TOKEN ?? process.env.REACT_APP_MAPBOX_TOKEN

export const mapboxSuggests = (q) => {
    const language = 'en'
    const limit = 10
    // const proximity= '100%2C0''
    const types = 'country,region,district,postcode,locality,city,place'
    // const bbox = '94,-6,110,6'
    const bbox = '94,-9,117,7.6'

    return axios.get(`${baseUrl}search/searchbox/v1/suggest?q=${q}&access_token=${access_token}&limit=${limit}&language=${language}&session_token=${session_token}&types=${types}&bbox=${bbox}`)
}


export const mapboxSuggestsRetrieve = (mapbox_id) => {

    return axios.get(`${baseUrl}search/searchbox/v1/retrieve/${mapbox_id}?access_token=${access_token}&session_token=${session_token}`)
}